import axios from "axios";
import config from "config";

const axiosInstance = axios.create({
  baseURL: config.baseURL,
  headers: {
    "Content-Type": "application/json",
  },
});

axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("accessToken");

    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status;
    const hasActiveSession = !!localStorage.getItem("accessToken");

    // A 401 means the authenticated session is no longer valid. Do not use a
    // native alert here; the inactivity warning is owned by useSessionTimeout.
    // Also leave 403 responses to the caller because they represent a lack of
    // permission, not an expired session.
    if (status === 401 && hasActiveSession) {
      localStorage.removeItem("accessToken");
      localStorage.removeItem("user");
      window.location.replace("/session/signin");
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;
